import React from 'react';
import Navbar from './components/NavBar';
import DisplayGrid from './components/DisplayGrid';
import Login from './components/LoginView';
import Map from './components/Map';
import Wishlist from './components/Wishlist';
import WishlistDetail from './components/WishlistDetail';
import ManageUsers from './components/ManageUsers';
import Cookies from 'universal-cookie';
import "./App.css";
import {authorizedFetch} from "./utils/authorizedFetch";
import {useAuth} from "./utils/useAuth";

function App() {
    const {login, isAuthenticated, getAccessToken, inProgress} = useAuth();

    const [user, setUser] = React.useState(null);
    const [events, setEvents] = React.useState([]);
    const [searchText, setSearchText] = React.useState('');
    const [allEvents, setAllEvents] = React.useState([]);
    const [selectedEvent, setSelectedEvent] = React.useState('');
    const [displays, setDisplays] = React.useState([]);
    const [wishlist, setWishlist] = React.useState(false);
    const [wishlistDetail, setWishlistDetail] = React.useState(false);
    const [map, setMap] = React.useState(false);
    const [manageUsers, setManageUsers] = React.useState(false);
    const [wishlistPacks, setWishlistPacks] = React.useState([]);
    const [currentPage, setCurrentPage] = React.useState(0);
    const [loading, setLoading] = React.useState(true);
    const [areas, setAreas] = React.useState([]);
    const [displayTypes, setDisplayTypes] = React.useState([]);
    const [selectedWishlist, getWishlistDetail] = React.useState([]);

    React.useEffect(() => {
        if (!isAuthenticated) return;

        const fetchData = async () => {
            setLoading(true);
            try {
                const token = await getAccessToken();
                if (!token) throw new Error("User not authenticated");

                const appUser = await authorizedFetch(
                    process.env.REACT_APP_API_ENDPOINT + "user",
                    {},
                    token
                );
                setUser(appUser);

                const cookies = new Cookies();
                cookies.set('hashCode', appUser.hashCode, {path: '/', maxAge: 31536000});

                const all = await authorizedFetch(
                    process.env.REACT_APP_API_ENDPOINT + "events",
                    {},
                    token
                );
                setAllEvents(all);

                const userEvents = all.filter(ev => appUser.eventIDs?.includes(ev.id));
                const sortedEvents = userEvents.sort((a, b) => parseFloat(b.timestamp) - parseFloat(a.timestamp));
                setEvents(sortedEvents);

                if (sortedEvents.length > 0) {
                    setSelectedEvent(sortedEvents[0]);
                    setAreas(sortedEvents[0].areas);
                    setDisplayTypes(sortedEvents[0].displayTypes);
                } else {
                    setSelectedEvent('');
                }

            } catch (err) {
                console.error("fetchData error:", err);
            }
        };

        fetchData();
    }, [isAuthenticated]);


    const handleSelectedEvent = (event) => {
        setSelectedEvent(event);
        setAreas(event.areas);
        setDisplayTypes(event.displayTypes);
    };

    return (
        isAuthenticated ?
            <React.Fragment>

                {map ? '' : <Navbar setManageUsers={setManageUsers} user={user} setLoading={setLoading}
                                    setCurrentPage={setCurrentPage} setWishlistDetail={setWishlistDetail}
                                    setWishlist={setWishlist} setMap={setMap} events={events}
                                    selectedEvent={selectedEvent} setSelectedEvent={handleSelectedEvent}
                                    displays={displays} setDisplays={setDisplays} setSearchText={setSearchText}/>
                } {
                map ? <Map setLoading={setLoading} setMap={setMap} selectedEvent={selectedEvent} displays={displays}
                           setDisplays={setDisplays}/> : (manageUsers ?
                    <ManageUsers setManageUsers={setManageUsers} events={allEvents} selectedEventId={selectedEvent.id}/> : (
                        wishlist
                            ?
                            (wishlistDetail ? <WishlistDetail user={user} loading={loading} setLoading={setLoading}
                                                              setWishlistDetail={setWishlistDetail}
                                                              getWishlistDetail={getWishlistDetail}
                                                              selectedWishlist={selectedWishlist}/> :
                                <Wishlist user={user} setWishlistDetail={setWishlistDetail} setWishlist={setWishlist}
                                          loading={loading} setLoading={setLoading} wishlistPacks={wishlistPacks}
                                          getWishlistDetail={getWishlistDetail} setWishlistPacks={setWishlistPacks}
                                          selectedEvent={selectedEvent}/>)
                            :
                            (selectedEvent === '' && events.length > 0) || (user && user.userRole && user.userRole.name !== 'admin') ?
                                <div className='error_message'><p>You are not authorized to access to Showroom Web</p>
                                </div>
                                :
                                <DisplayGrid user={user} setMap={setMap} setWishlist={setWishlist}
                                             currentPage={currentPage} setCurrentPage={setCurrentPage} loading={loading}
                                             setLoading={setLoading} displays={displays} setDisplays={setDisplays}
                                             selectedEvent={selectedEvent} searchText={searchText} areas={areas}
                                             displayTypes={displayTypes} events={events}></DisplayGrid>))

            }
            </React.Fragment>
            :
            < Login login={login}/>
    )
}

export default App;
